import * as Yup from 'yup';

import { contactsValidationSchema } from 'src/common/validation/contact';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';
import type { IContactWithReferenceCount } from 'src/types/IContactWithReferenceCount';

export type ICustomerLeadContactTabFormValues = {
  contacts: IContactWithReferenceCount[];
};

export const customerLeadContactTabValidationSchema = Yup.object<ICustomerLeadContactTabFormValues>().shape({
  contacts: contactsValidationSchema,
});

export function toCustomerLeadContactTabInitialValues(
  customerProductLead: ICustomerLeadProduct
): ICustomerLeadContactTabFormValues {
  return {
    contacts: customerProductLead.contacts,
  };
}
